export class SclMapConstantService {
  static MAP_PRIMARY_ASSET = 'https://fileshare.formbird.com/fb/sc-component/map-icons/primary.png';
  static MAP_SECONDARY_ASSET = 'https://fileshare.formbird.com/fb/sc-component/map-icons/secondary.png';
  static MAP_MARKER = 'https://fileshare.formbird.com/fb/sc-component/map-icons/marker.png';
  static STREET_SUBPREMISE = 'subpremise';
  static STREET_STREET_NUMBER = 'street_number';
  static STREET_ROUTE = 'route';
  static STREET_ADMINISTRATIVE_AREA_LEVEL_1 = 'administrative_area_level_1';
  static STREET_LOCALITY = 'locality';
  static STREET_POSTAL_CODE = 'postal_code';
  static STREET_COUNTRY = 'country';
  static ASSET_PRIMARY_TYPE = 'primary';
  static ASSET_SECONDARY_TYPE = 'secondary';
  static ASSET_PRIMARY_CAPTION = 'Primary';
  static ASSET_SECONDARY_CAPTION = 'Secondary';
  static AVL_SPEED_BEGINNING = 'https://fileshare.formbird.com/fb/sc-component/map-icons/pin30';
  static HEADING_THRESHOLD_H0 = 22.5;
  static HEADING_THRESHOLD_H1 = 67.5;
  static HEADING_THRESHOLD_H2 = 112.5;
  static HEADING_THRESHOLD_H3 = 157.5;
  static HEADING_THRESHOLD_H4 = 202.5;
  static HEADING_THRESHOLD_H5 = 247.5;
  static HEADING_THRESHOLD_H6 = 292.5;
  static HEADING_THRESHOLD_H7 = 337.5;
  static DEFAULT_SEARCH_DELAY = 500;
  static DEFAULT_SEARCH_LENGTH = 3;
  static AVL_SPEED_H0 = '_h0';
  static AVL_SPEED_H1 = '_h1';
  static AVL_SPEED_H2 = '_h2';
  static AVL_SPEED_H3 = '_h3';
  static AVL_SPEED_H4 = '_h4';
  static AVL_SPEED_H5 = '_h5';
  static AVL_SPEED_H6 = '_h6';
  static AVL_SPEED_H7 = '_h7';
  static EPSG_3857 = 'EPSG:3857';
  static EPSG_4326 = 'EPSG:4326';
  static MAP_MARKER_ARROW = 'https://fileshare.formbird.com/fb/sc-component/map-icons/arrow.png';
  static MAP_MARKER_CROSS_GREEN = 'https://fileshare.formbird.com/fb/sc-component/map-icons/CrosshairGreen.gif';
  static PRIMARY_ASSET = '{' +
  '"type":"Feature",' +
  '"properties":{' +
  '"type":"primaryAssets",' +
  '"linkAssets":[]' +
  '}' +
  '}';
  static SECONDARY_ASSET = '{' +
  '"type":"Feature",' +
  '"properties":{' +
  '"type":"secondaryAssets",' +
  '"linkAssets":[]' +
  '}' +
  '}';
  static STREET = {
    type: 'Feature',
    properties:{
      type: 'street',
      unitNo: '',
      streetNo: '',
      street: '',
      suburb: '',
      postcode: '',
      locationDescription: '',
      country: '',
      iconImage: '',
      iconSize: '',
      state: ''
    },
    geometry:{
      type: 'Point',
      coordinates:[]
    }
  }; // 15925
  static ASSET_FULL_INITIAL_DATA = '{' +
  '"type": "FeatureCollection",' +
  '"features": [' +
  '{' +
  '"type" : "Feature",' +
  '"properties" : {' +
  '"type" : "street",' +
  '"unitNo" : "",' +
  '"streetNo" : "",' +
  '"street" : "",' +
  '"suburb" : "",' +
  '"postcode" : "",' +
  '"locationDescription" : "",' +
  '"country" : "",' +
  '"iconImage" : "",' +
  '"iconSize" : ""' +
  '},' +
  '"geometry" : {' +
  '"type" : "Point",' +
  '"coordinates": []' +
  '}' +
  '},' +
  '{' +
  '"type" : "Feature",' +
  '"properties" : {' +
  '"type" : "primaryAssets",' +
  '"linkAssets" : []' +
  '}' +
  '},' +
  '{' +
  '"type" : "Feature",' +
  '"properties" : {' +
  '"type" : "secondaryAssets",' +
  '"linkAssets" : []' +
  '}' +
  '}' +
  ']' +
  '}';
  static STREET_INITIAL_DATA = '{' +
  '"type": "FeatureCollection",' +
  '"features": [' +
  '{' +
  '"type" : "Feature",' +
  '"properties" : {' +
  '"type" : "street",' +
  '"unitNo" : "",' +
  '"streetNo" : "",' +
  '"street" : "",' +
  '"suburb" : "",' +
  '"postcode" : "",' +
  '"locationDescription" : "",' +
  '"country" : "",' +
  '"iconImage" : "",' +
  '"iconSize" : ""' +
  '},' +
  '"geometry" : {' +
  '"type" : "Point",' +
  '"coordinates": []' +
  '}' +
  '}' +
  ']' +
  '}';
  static STREET_INITIAL_HEADER = '{' +
  '"type" : "FeatureCollection",' +
  '"features" : []' +
  '}';
  static STREET_INITIAL = '{' +
  '"type": "Feature",' +
  '"properties" : {' +
  '"type" : "street"' +
  '}' +
  '}';
  static MANDATORY_DEFAULT = [
    'unitNo',
    'streetNo',
    'street',
    'suburb',
    'postcode',
    'country',
    'state',
    'locationDescription',
    'coordinates',
    'primaryAsset',
    'secondaryAsset'
  ];
  static DEFAULT_MAP_PARAMETERS = { 
    mapViews: [
      {
        serverType: 'tile',
        url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
        crossOrigin: null
      }
    ] 
  }; // 15754
}
